// alert('지환스크립트 연결');

// 지환 HEADER FIXED 1024까지
// (function () {
//   var DEBUG = false;
//   function log() { if (DEBUG) console.log('[b7_custom]', ...arguments); }

//   var body = document.body;
//   var isHome =
//     body.classList.contains('template-index') ||
//     body.classList.contains('index-template') ||
//     window.location.pathname === '/';
//   if (!isHome) { log('not home'); return; }
//   log('home detected');

//   var css = `
//     body:is(.template-index, .index-template).home-at-top .header-sticky { position: fixed !important; top:49px !important; }
//     body:is(.template-index, .index-template).home-at-top .header__bottom { background: transparent !important; }
//     body:is(.template-index, .index-template).home-at-top .header__bottom:after { background: transparent !important; }
//     body:is(.template-index, .index-template).home-at-top .header__top { background: transparent !important; }
//     body:is(.template-index, .index-template).home-at-top .header__navigation .reversed-link { color:#fff !important; }

//     // body:is(.template-index, .index-template).home-at-top .header__navigation .reversed-link:hover { color:#000 !important; }
//     body:is(.template-index, .index-template).home-at-top #Mega-menu-item-custom_card_7tLh9A .reversed-link:hover { color:#000 !important; }
    
//     body:is(.template-index, .index-template).home-at-top .header__navigation .reversed-link__text { color:#000 !important; }
//     body:is(.template-index, .index-template).home-at-top .header__icons .account-button { color:#fff !important; }
//     body:is(.template-index, .index-template).home-at-top .header__icons .cart-drawer-button { color:#fff !important; }
//     body:is(.template-index, .index-template).home-at-top .header__logo img { filter: brightness(0) invert(1) !important; }
//     body:is(.template-index, .index-template).home-at-top .header--show-sperator-line .header__bottom { border-block-end: none !important; }

//   `;
//   var styleEl = document.getElementById('b7-home-header-style');
//   if (!styleEl) {
//     styleEl = document.createElement('style');
//     styleEl.id = 'b7-home-header-style';
//     document.head.appendChild(styleEl);
//   }
//   styleEl.textContent = css;

//   var THRESHOLD = 30; 

//   function update() {
//     var atTop = window.scrollY <= THRESHOLD;
//     body.classList.toggle('home-at-top', atTop);
//     log('update: scrollY=', window.scrollY, '=> home-at-top:', atTop);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', update);
//   } else {
//     update();
//   }

//   window.addEventListener('scroll', update, { passive: true });
//   window.addEventListener('resize', update);

//   window.addEventListener('load', function () {
//     setTimeout(update, 0);
//     setTimeout(update, 200);
//   });

//   var mo = new MutationObserver(function () { update(); });
//   mo.observe(document.documentElement, { childList: true, subtree: true });
// })();


// (function () {
//   // 홈 페이지만 작동
//   var isHome =
//     document.body.classList.contains('template-index') ||
//     document.body.classList.contains('index-template') ||
//     window.location.pathname === '/';
//   if (!isHome) return;

//   document.addEventListener('DOMContentLoaded', function () {
//     const reversedLinks = document.querySelectorAll('.reversed-link');
//     if (!reversedLinks.length) return;

//     reversedLinks.forEach(link => {
//       link.addEventListener('mouseenter', () => {
//         if (document.body.classList.contains('home-at-top')) {
//           reversedLinks.forEach(l => l.classList.add('hovered'));
//         }
//       });

//       link.addEventListener('mouseleave', () => {
//         reversedLinks.forEach(l => l.classList.remove('hovered'));
//       });
//     });
//   });
// })();



// 지환 HEADER FIXED 1024까지
(function () {
  var isHome =
    document.body.classList.contains('template-index') ||
    document.body.classList.contains('index-template') ||
    window.location.pathname === '/';
  if (!isHome) return;

  const MOBILE_BREAKPOINT = 1024;

  function isDesktop() {
    return window.innerWidth >= MOBILE_BREAKPOINT;
  }

  var THRESHOLD = 120;
  function update() {
    if (!isDesktop()) {
      document.body.classList.remove('home-at-top');
      return;
    }
    var atTop = window.scrollY <= THRESHOLD;
    document.body.classList.toggle('home-at-top', atTop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);

  document.addEventListener('DOMContentLoaded', function () {
    const reversedLinks = document.querySelectorAll('.reversed-link');
    if (!reversedLinks.length) return;

    reversedLinks.forEach(link => {
      link.addEventListener('mouseenter', () => {
        if (isDesktop() && document.body.classList.contains('home-at-top')) {
          reversedLinks.forEach(l => l.classList.add('hovered'));
        }
      });
      link.addEventListener('mouseleave', () => {
        reversedLinks.forEach(l => l.classList.remove('hovered'));
      });
    });
  });
})();

// predictive-search-open
// SEARCH OPEN HEADER 

document.addEventListener('DOMContentLoaded', function () {
  const THRESHOLD = 80; 

  function isHomeTemplate() {
    const body = document.body;
    return (
      body.classList.contains('template-index') ||
      body.classList.contains('index-template')
    );
  }

  function isDesktop() {
    return window.innerWidth >= 1024;
  }

  function isSearchOpen() {
    const predictive = document.querySelector('predictive-search');
    if (!predictive) return false;
    return predictive.classList.contains('predictive-search-open');
  }

  function clearReversedLinkForceBlack() {
    document
      .querySelectorAll('.reversed-link--force-black')
      .forEach(function (el) {
        el.classList.remove('reversed-link--force-black');
      });
  }

  function updateHomeAtTop() {
    const body = document.body;

    if (!isHomeTemplate()) {
      body.classList.remove('home-at-top');
      clearReversedLinkForceBlack();
      return;
    }

    if (!isDesktop()) {
      body.classList.remove('home-at-top');
      clearReversedLinkForceBlack();
      return;
    }

    if (isSearchOpen()) {
      body.classList.remove('home-at-top');
      clearReversedLinkForceBlack();
      return;
    }

    const atTop = window.scrollY <= THRESHOLD;
    body.classList.toggle('home-at-top', atTop);

    if (!atTop) {
      clearReversedLinkForceBlack();
    }
  }

  function setupReversedLinkHoverSync() {
    const navLinks = document.querySelectorAll(
      '.header__navigation .reversed-link'
    );
    const allLinks = document.querySelectorAll('.reversed-link');

    if (!navLinks.length || !allLinks.length) return;

    function applyHover(active) {
      if (
        !isHomeTemplate() ||
        !isDesktop() ||
        isSearchOpen() ||
        !document.body.classList.contains('home-at-top')
      ) {
        clearReversedLinkForceBlack();
        return;
      }

      if (active) {
        allLinks.forEach(function (link) {
          link.classList.add('reversed-link--force-black');
        });
      } else {
        clearReversedLinkForceBlack();
      }
    }

    navLinks.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        applyHover(true);
      });
      link.addEventListener('mouseleave', function () {
        applyHover(false);
      });

      link.addEventListener('focus', function () {
        applyHover(true);
      });
      link.addEventListener('blur', function () {
        applyHover(false);
      });
    });
  }

  function setupSearchObserver() {
    const predictive = document.querySelector('predictive-search');
    if (!predictive) return;

    const observer = new MutationObserver(function (mutations) {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          updateHomeAtTop();
          clearReversedLinkForceBlack();
        }
      }
    });

    observer.observe(predictive, { attributes: true });
  }

  window.addEventListener('scroll', updateHomeAtTop);
  window.addEventListener('resize', updateHomeAtTop);

  updateHomeAtTop();
  setupReversedLinkHoverSync();
  setupSearchObserver();
});







